module.exports = __webpack_public_path__ + "static/img/20016 (1).5898200.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20016 (1).webp
// module id = WDFc
// module chunks = 14